// Add all your reducers here for combining into one reducer
/* eslint-disable no-param-reassign */

import { Map } from 'immutable';
import userPage from './containers/UserPage/reducer';
import loginPage from './containers/LoginPage/reducer';
import homePage from './containers/HomePage/reducer';
import headerContainer from './containers/HeaderContainer/reducer';
import restaurantDealsPage from './containers/RestaurantDeals/reducer';
import restaurantsListPage from './containers/RestaurantsList/reducer';
import restaurantDetails from './containers/RestaurantDetails/reducer';
import GiftCardLanding from './containers/GiftCardLanding/reducer';
import giftCardsList from './containers/GiftCardsList/reducer';
import giftCardProduct from './containers/GiftCardProduct/reducer';
import payBalance from './containers/PayBalance/reducer';
import giftCardCartPage from './containers/GiftCardCart/reducer';
import redeemZsc from './containers/RedeemZsc/reducer';
import deliveryAddress from './containers/DeliveryAddress/reducer';
import orderSummary from './containers/OrderSummary/reducer';
import zingerCardDetailS from './containers/_ZingerCardDetails/reducer';
import myBookings from './containers/MyBookings/reducer';
import deliveryAdd from './containers/_DeliveryAdd/reducer';
import myEGiftCards from './containers/MyEGiftCards/reducer';
import profile from './containers/Profile/reducer';
import networkCards from './containers/NetworkCards/reducer';
import myOrders from './containers/MyOrders/reducer';
import orderDetails from './containers/OrderDetails/reducer';
import contactUs from './containers/ContactUs/reducer';
import partnerWithUs from './containers/PartnerWithUs/reducer';
import planAParty from './containers/PlanAParty/reducer';
import activateZsc from './containers/ActivateZsc/reducer';
import emailVerification from './containers/EmailVerification/reducer';
import yscTransactionLimits from './containers/YscTransactionLimits/reducer';
import yesBankTransactionLimits from './containers/YesBankTransactionLimits/reducer';
import indusindMinKyc from './containers/IndusindMinKyc/reducer';
import yscCardActions from './containers/YscCardActions/reducer';
import yesBankRenewalManagement from './containers/YesBankRenewalManagement/reducer';
import yesBankReplaceCard from './containers/YesBankReplaceCard/reducer';
import yscWalletLockUnlock from './containers/YscWalletLockUnlock/reducer';
import indusindFaqs from './containers/IndusindZingerCardsFaqs/reducer';
import yesBankFaqs from './containers/YesBankFaQs/reducer';

const initialState = Map({});

/**
 * @todo: on mounting of the root file 'global' need to be initialized so that can be used all over the application
 * @desc {service error, alerts, change in the header or footer}
 */
const reducers = Map({
  planAParty,
  partnerWithUs,
  orderDetails,
  myOrders,
  networkCards,
  profile,
  myEGiftCards,
  myBookings,
  zingerCardDetailS,
  orderSummary,
  deliveryAdd,
  deliveryAddress,
  redeemZsc,
  giftCardCartPage,
  payBalance,
  giftCardProduct,
  giftCardsList,
  userPage,
  loginPage,
  homePage,
  headerContainer,
  restaurantDetails,
  restaurantDealsPage,
  restaurantsListPage,
  GiftCardLanding,
  contactUs,
  activateZsc,
  emailVerification,
  yscTransactionLimits,
  yesBankTransactionLimits,
  indusindMinKyc,
  yscCardActions,
  yesBankRenewalManagement,
  yesBankReplaceCard,
  yscWalletLockUnlock,
  indusindFaqs,
  yesBankFaqs,
});

function combineReducers(state = initialState, action) {
  reducers.forEach((reducer, key) => {
    state = state.set(key, reducer(state.get(key), action));
  });

  return state;
}

export default combineReducers;



// WEBPACK FOOTER //
// client/reducers.js